import { toHaveFormValues } from '@testing-library/jest-dom/dist/matchers'
import React from 'react'

export default function FormInput (props) {
    const {values, update, submit, isDisabled} = props

    const onChange = evt => {
        const { name, value } = evt.target
        update (name, value)
        }

    const onSubmit = evt => {
        evt.preventDefault();
        submit();
        }
  
return (
    <div>
        {values.latitude === '' ? 
         (
            <form className="Form"  onSubmit={onSubmit}>
                <label>Select Location from Map:</label>
                <div className = "Input3">
                    <input className="FormInput"
                        name="latitude"
                        type="text"
                        placeholder="Latitude"
                        value={values.latitude}
                        onChange={onChange}
                    />
                    <input className="FormInput"
                        name="longitude"
                        type="text"
                        placeholder="Longitude"
                        value={values.longitude}
                        onChange={onChange}
                        />
                </div>
         </form> 
         ) : (
        <div>
        <h4>Please fill out all inputs to calculate UbiGro's benefits for your greenhouse.</h4>
        <form className="Form"  onSubmit={onSubmit}>
            <div >
            <label>Select Location from Map:</label>
                <div className = "Input3">
                <input className="FormInput"
                    name="latitude"
                    type="text"
                    placeholder="Latitude"
                    value={values.latitude}
                    onChange={onChange}
                />
                <input className="FormInput"
                    name="longitude"
                    type="text"
                    placeholder="Longitude"
                    value={values.longitude}
                    onChange={onChange}
                />
                </div>
                <label>Name:</label>
                <div className = "Input1">
                <input className="FormInput"
                    name="firstname"
                    type="firstname"
                    placeholder="First Name"
                    value={values.firstname}
                    onChange={onChange}
                />
                <input className="FormInput"
                    name="lastname"
                    type="lastname"
                    placeholder="Last Name"
                    value={values.lastname}
                    onChange={onChange}
                />
                </div>
                <label>Contact:</label>
                <div className = "Input2">
                <input className="FormInput"
                    name="company"
                    type="text"
                    placeholder="Company Name"
                    value={values.company}
                    onChange={onChange}
                />
                <input className="FormInput"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={values.email}
                    onChange={onChange}
                />
                </div>
                <label>Greenhouse:</label> 
                <div className = "Input4">
            <select value={values.crop} name="crop" onChange={onChange}>
                    <option value=''> Select Crop </option>
                    <option value='Tomato'>Tomatoes</option>
                    <option value='Lettuce'>Lettuce</option>
                    <option value='Cannabis'>Cannabis</option>
                    <option value='Other'>Other</option>
                    </select>
                
                    <select value={values.covertype} name="covertype" onChange={onChange}>
                    <option value=''>   Select Greenhouse Cover Type  </option>
                    <option value='Glass'>Glass</option>
                    <option value='Acrylic'>Acrylic</option>
                    <option value='ETFE'>ETFE(F-Clean)</option>
                    <option value='Poly Carb 1 Wall'>Poly Carb 1 Wall</option>
                    <option value='Poly Carb 2 Wall'>Poly Carb 2 Wall</option>
                    <option value='PolyE 1L'>PolyE 1L</option>
                    <option value='PolyE 2L'>PolyE 2L</option>
                    <option value='PolyE 3L'>PolyE 3L</option>
                    <option value='Unknown'>Unknown</option>
                    </select>
                    
                    <select value={values.clarity} name="clarity" onChange={onChange}>
                    <option value=''>  Select Clarity  </option>
                    <option value='Most Diffuse'>Most Diffuse</option>
                    <option value='In-Between'>Inbetween</option>
                    <option value='Most Clear'>Most Clear</option>
                    <option value='Unknown'>Unknown</option>
                    </select>
                </div>
            </div>
            <div className="subtext">
                UbiQD, Inc. needs the contact information you provide to us to send results from this tool. You may unsubscribe from these communications at any time.
            </div>
            <div class="button-container" >
                <button disabled={isDisabled()} className="submitButton">submit</button>
            </div> 
        </form>
        </div>)}
    </div>
)}
